import * as styles from './empty-cell.scss';

export function EmptyCell(): JSX.Element {
    return <div className={styles.empty_cell}>—</div>;
}
